import { render, staticRenderFns } from "./GaussLegenda.vue?vue&type=template&id=022db13d&scoped=true&"
import script from "./GaussLegenda.vue?vue&type=script&lang=js&"
export * from "./GaussLegenda.vue?vue&type=script&lang=js&"
import style0 from "./GaussLegenda.vue?vue&type=style&index=0&id=022db13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022db13d",
  null
  
)

export default component.exports